var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"xs":"6","sm":"6","md":"8","lg":"8"}},[_c('pie-chart',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"data":_vm.chartEvAudiosTip,"dark":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }